import React, { useState, useRef, useEffect } from 'react';
import './ExpandIcon.scss';

const ExpandIcon = ({ id, isSvg }) => {
  const [isExpand, setIsExpand] = useState(false);
  const btnRef = useRef(null);
  let mediaContainerElem;

  const expandMedia = () => {
    const currentMediaElem = btnRef.current.closest('.media');
    const ratioElement = currentMediaElem.querySelector('.Ratio');
    if (currentMediaElem.firstElementChild.classList.contains('media-title')) {
      mediaContainerElem = currentMediaElem.children[1];
    } else {
      mediaContainerElem = currentMediaElem.children[0];
    }

    const bodyEle = document.getElementsByTagName('body')[0];

    if (isExpand) {
      setIsExpand(false);
      currentMediaElem.classList.remove('mediaExpandedView');
      bodyEle.classList.remove('has-expanded-media');
      mediaContainerElem.removeAttribute('style');
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 0);
    } else {
      setIsExpand(true);
      const nw =
        (ratioElement.getBoundingClientRect().width *
          (window.innerHeight - 100)) /
        ratioElement.getBoundingClientRect().height;

      mediaContainerElem.style = `width: ${nw}px;`;
      currentMediaElem.classList.add('mediaExpandedView');
      bodyEle.classList.add('has-expanded-media');
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 0);
    }
  };

  useEffect(() => {
    if (btnRef.current) {
      btnRef.current.blur();
    }
  }, [btnRef]);

  return isSvg ? (
    <div
      id={`expand-media-${id}`}
      ref={btnRef}
      className={isExpand ? 'showExpandIcon expand-media' : 'expand-media'}
      onClick={() => expandMedia()}
    ></div>
  ) : (
    <div
      id={`expand-media-${id}`}
      ref={btnRef}
      className={isExpand ? 'showExpandIcon expand-media' : 'expand-media'}
    >
      <button
        id={`media-Expand-ico-${id}`}
        className={`btn btn--icon btn--small btn--secondary expand-btn${
          isExpand ? ' isExpanded' : ''
        }`}
        onClick={() => expandMedia()}
        type="button"
      >
        <span
          className={isExpand ? 'icon-exit-fullscreen' : 'icon-fullscreen'}
        />
      </button>
    </div>
  );
};
export default ExpandIcon;
